<template>
    <div
        v-if="showModal"
        class="fixed top-0 left-0 z-10 flex items-center justify-center w-screen h-screen"
    >
        <div
            class="relative z-20 flex flex-col w-1/3 px-8 py-4 space-y-4 rounded-panel bg-headerGray"
        >
            <input
                type="text"
                class="px-4 py-2 rounded-full focus:outline-none"
                :placeholder="placeholder"
                v-model="value"
            />
            <button
                class="px-4 py-2 font-medium text-white uppercase rounded-full bg-success focus:outline-none"
                @click="save()"
            >
                Save
            </button>
        </div>
        <div
            class="absolute top-0 left-0 z-0 z-10 w-screen h-screen bg-black opacity-70"
            @click="close()"
        ></div>
    </div>
</template>
<script>
export default {
    props: ['placeholder'],
    data() {
        return {
            showModal: false,
            value: '',
            edit: false,
        };
    },
    methods: {
        show(value) {
            if (typeof value !== 'undefined') {
                this.value = value;
                this.edit = true;
            }
            this.showModal = true;
        },
        close() {
            this.showModal = false;
        },
        save() {
            if (this.edit) {
                this.$emit('edit', this.value);
            } else {
                this.$emit('save', this.value);
            }
            this.value = '';
            this.edit = false;
            this.close();
        },
    },
};
</script>
